export default "__VITE_ASSET__D1Zt_t83__"